import domReady from '@roots/sage/client/dom-ready';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'swiper';
import.meta.glob([
  '../images/**',
  '../fonts/**',
]);
// import '../css/app.css';
// import Common from './common'
import '../react/main.jsx';

import Main from './main'
// import './wc-ajax-cart';
import './wc-default-variation-handler';
/**
 * Application entrypoint
 */
domReady(async () => {
    Main.init();
})